import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import AISuggestionDeletionSource from 'models/audioEditor/AISuggestionDeletionSource';
import DeletionSource from 'models/audioEditor/DeletionSource';
import TextSearchDeletionSource from 'models/audioEditor/TextSearchDeletionSource';


const deletionSourceContructors = [DeletionSource,
    TextSearchDeletionSource,
    AISuggestionDeletionSource,
];
const DeletionSourceFactory =  Backbone.Model.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
     
    },

    createDeletionSourceForSerializedData : function(serializedData){
        if(serializedData){
            for(let i =0; i < deletionSourceContructors.length; i++){
                const contructorClass = deletionSourceContructors[i];
                if(serializedData.classname === contructorClass.CLASSNAME){
                    const deletionSourceInstance = new contructorClass({});
                    deletionSourceInstance.restoreFromSerializedData(serializedData);
                    return deletionSourceInstance;
                }
            }
        }
        return null;
    },


});


const deletionSourceFactoryInstance = new DeletionSourceFactory();

export default {
    getInstance : function() {
        return deletionSourceFactoryInstance;
    }
}; 